/**
 * @generated SignedSource<<bdf401725a79bf7d20d26bebeeaedf77>>
 * @relayHash eba1c502749083d7858f23a8a4380f36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b3b9d98ccf886b12917104f999ff14f90165d6108a2547ca1fbf4ca98d929e1e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareSummaryEmbedAppQuery } from './JiraSoftwareSummaryEmbedAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareSummaryEmbedAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b3b9d98ccf886b12917104f999ff14f90165d6108a2547ca1fbf4ca98d929e1e",
    "metadata": {},
    "name": "JiraSoftwareSummaryEmbedAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
